// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.streeteasy.RentalManagerUserStreetEasyWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserStreetEasyWebApiHandler_linkUser } from '@zg-rentals/ts-rental-manager-api-client';

import type { LinkStreetEasyUserRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserStreetEasyWebApiHandler_linkUser_Args {
  postData: LinkStreetEasyUserRequestDto;
}

export type RentalManagerUserStreetEasyWebApiHandler_linkUser_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserStreetEasyWebApiHandler_linkUser_Args
>;

/**
 * Link the session's StreetEasy user to the account and refresh its listing permissions
 */
export const useRentalManagerUserStreetEasyWebApiHandler_linkUser = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserStreetEasyWebApiHandler_linkUser_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserStreetEasyWebApiHandler_linkUser_Args) =>
      RentalManagerUserStreetEasyWebApiHandler_linkUser(args.postData, httpClient),
  });
};
